import React from 'react';
import BaseField, { BaseFieldProps } from '../../Inputs/BaseField/BaseField';
import ECardFolderSelect from './ECardFolderSelect';

interface Props extends BaseFieldProps {
	patientId: string;
}
const ECardFolderSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<ECardFolderSelect patientId={props.patientId} />
	</BaseField>
);

export default ECardFolderSelectField;
